import api from "./api";

// 删除模版
export const agentV2DeleteTemplate = async ({ templateId, agentId, userId }: { templateId: string; agentId: string; userId: string }) => {
  const res = await api.post<unknown>("/agent-v2/delete-template", {
    template_id: templateId,
    agent_id: agentId,
    user_id: userId,
  });
  return res;
};
